import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import {connectToStores} from 'epic-alt-utils/index';
import {withRouter} from 'react-router';
import {LoginStore, LocalizationStore, AppConfigStore, FullpageStore, HomeStore, HeaderStore} from './stores';
import getRoutes from './routes/routes';
import {getMetaTags} from './utils/Utils';
import {EpicGamesNavWrapper} from './components';

@connectToStores
class App extends React.Component {
    static propTypes = {
        location: PropTypes.object,
        localizationStore: PropTypes.object,
        headerStore: PropTypes.object,
        loginStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        loadingSection: PropTypes.number,
        modsEnabled: PropTypes.bool,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        msie: PropTypes.bool,
        firefox: PropTypes.bool
    };

    static getStores() {
        return [LoginStore, LocalizationStore, AppConfigStore, FullpageStore, HomeStore, HeaderStore];
    }

    static getPropsFromStores() {
        return {
            loginStore: LoginStore.getState(),
            localizationStore: LocalizationStore.getState(),
            headerStore: HeaderStore.getState(),
            appConfigStore: AppConfigStore.getState(),
            loadingSection: FullpageStore.getState().loadingSection,
            modsEnabled: HomeStore.getState().modsEnabled,
            mobile: HeaderStore.getState().mobile(),
            tablet: HeaderStore.getState().tablet(),
            msie: HeaderStore.getState().msie(),
            firefox: HeaderStore.getState().firefox()
        };
    }

    render() {
        const classes = classNames('odin-wrapper', {
            mobile: this.props.mobile,
            tablet: this.props.tablet,
            msie: this.props.msie,
            firefox: this.props.firefox
        });
        const routes = getRoutes();
        const tags = getMetaTags(this.props.localizationStore);
        return (
            <div>
                <Helmet
                    meta={tags}
                    title={this.props.localizationStore.message('epic.odin.name')} />
                <EpicGamesNavWrapper {...this.props} />
                <div className={classes}>
                    {routes}
                </div>
            </div>
        );
    }
}

export default withRouter(App);
